// extracted by mini-css-extract-plugin
export var arrows = "_5z-5";
export var decrementer = "_5z-9";
export var disabled = "_5z-3";
export var error = "_5z-1";
export var hiddenText = "_5z-a";
export var incrementer = "_5z-8";
export var input = "_5z-7";
export var inputWrapper = "_5z-0";
export var leadingIcon = "_5z-b";
export var readonly = "_5z-2";
export var regular = "_5z-6";
export var small = "_5z-4";